import { useEffect, useRef } from 'react';
import { analytics } from '../lib/analytics';

export function useNudgeImpression(nudgeId: string, visible: boolean, meta?: Record<string, string | number | boolean | null | undefined>) {
  const logged = useRef(false);

  useEffect(() => {
    if (visible && !logged.current) {
      analytics.emit('nudge_impression', { nudge_id: nudgeId, ...meta });
      logged.current = true;
    }
  }, [visible, nudgeId, meta]);
}
